import React from 'react';
import CustomButton from './CustomButton';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import DownloadIcon from '@mui/icons-material/Download'
import './PetCheirosoSection.css';

const PetCheirosoSection = () => {
  return (
    <section className="pet-cheiroso-section">
      <div
        className="pet-cheiroso-background"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/cachrro-preto.png)`,
        }}
      ></div>
      <div className="pet-cheiroso-content">
        <div className="pet-cheiroso-text">
          <h2 className="pet-cheiroso-title">
            Seu pet sempre cheiroso, sem surpresa na conta!
          </h2>
          <p className="pet-cheiroso-subtitle">
            Sem fidelidade obrigatória. Você no controle.
          </p>

          <div className="pet-cheiroso-features">
            <div className="pet-cheiroso-feature-item">
              <div className="pet-cheiroso-feature-icon-wrapper">
                <LocalOfferIcon className="pet-cheiroso-feature-icon" />
              </div>
              <div className="pet-cheiroso-feature-content">
                <h3 className="pet-cheiroso-feature-title">Preço previsível</h3>
                <p className="pet-cheiroso-feature-description">
                  Sem sustos no fim do mês. Você sabe exatamente quanto vai pagar antes de agendar.
                </p>
              </div>
            </div>

            <div className="pet-cheiroso-feature-item">
              <div className="pet-cheiroso-feature-icon-wrapper">
                <CalendarTodayIcon className="pet-cheiroso-feature-icon" />
              </div>
              <div className="pet-cheiroso-feature-content">
                <h3 className="pet-cheiroso-feature-title">Agende em segundos</h3>
                <p className="pet-cheiroso-feature-description">
                  Escolha o melhor horário no app e pronto. Simples, rápido e sem complicação.
                </p>
              </div>
            </div>

            <div className="pet-cheiroso-feature-item">
              <div className="pet-cheiroso-feature-icon-wrapper">
                <VerifiedUserIcon className="pet-cheiroso-feature-icon" />
              </div>
              <div className="pet-cheiroso-feature-content">
                <h3 className="pet-cheiroso-feature-title">Rede verificada</h3>
                <p className="pet-cheiroso-feature-description">
                  Parceiros verificados e confiáveis. Seu pet em boas mãos.
                </p>
              </div>
            </div>
          </div>

          <div className="pet-cheiroso-button">
            <CustomButton
              variant="contained"
              sx={{
                backgroundColor: '#FF914D',
                color: '#FFFFFF',
                padding: '12px 24px',
                fontSize: '15px',
                '&:hover': {
                  backgroundColor: '#e67e3d',
                },
              }}
            >
              <DownloadIcon />
              Baixar para iOS
            </CustomButton>

            <CustomButton
              variant="contained"
              sx={{
                fontSize: '15px',
                padding: '12px 24px',
              }}
            >
              <DownloadIcon />
              Baixar para Android
            </CustomButton>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PetCheirosoSection;

